import createPlugin from "./createPlugin";
import TrustpilotRenderer from "./Renderer";

const TrustpilotPlugin = (settings) =>
    createPlugin({
        Renderer: TrustpilotRenderer,
        Controls: () => null,
        ...settings,
    });

const Trustpilot = TrustpilotPlugin();
export default Trustpilot;

export { TrustpilotPlugin, TrustpilotRenderer };
